import * as utils from "./utils";
import instanceNew from "services/instance-new";
import {isEmpty} from "lodash";
import store from "../../redux/store";

export const sendSMS = async (data) => {
    try {
        const response = await instanceNew.post('/common/sendSMS', data);
        return response.data;
    } catch (err) {
        ////     // console.log("Error : ",err);
    }
}

export const sendOTP = async (mobileNumber, portal) => {
    try {
        const response = await instanceNew.post('/common/sendOTP', utils.sendOTPRequest(mobileNumber, portal));
        return utils.sendOTPResponse(response);
    } catch (err) {
        ////     // console.log("Error : ",err);
    }
}

export const sendOTPwithFlag = async (mobileNumber, portal, id) => {
    try {
        const response = await instanceNew.post('/common/sendOTPWithFlag', utils.sendOTPWithFlagRequest(mobileNumber, portal, id));
        return utils.sendOTPResponse(response);
    } catch (err) {
        ////     // console.log("Error : ",err);
    }
}


export const verifyOTP = async (mobileNumber, otpCode) => {
    try {
        const response = await instanceNew.post('/common/validateOTP', utils.verifyOTPRequest(mobileNumber, otpCode));
        return utils.verifyOTPResponse(response);
    } catch (err) {
        ////     // console.log("Error : ",err);
    }
}

export const validateOTPWithFlag = async (mobileNumber, otpCode, id, isInternal) => {
    try {
        const response = await instanceNew.post('/common/validateOTPWithFlag', utils.verifyOTPWithFlagRequest(mobileNumber, otpCode, id, isInternal));
        return utils.verifyOTPResponse(response);
    } catch (err) {
        ////     // console.log("Error : ",err);
    }
}

export const verifyOTPNew = async (mobileNumber, otpCode) => {
    try {
        const response = await instanceNew.post('/common/validateOTPNew', utils.verifyOTPRequest(mobileNumber, otpCode));
        return response;
    } catch (error) {
        return Promise.reject(error)
    }
}


// payments
export const getCardPayment = async (data) => {
    const request = {...data}
    request.source.type = "token";
    try {
        const response = await instanceNew.post('/payment/getCardPayment', request);
        return response;
    } catch (err) {
        return err;
    }
};

export const getCardPaymentSMEMedical = async (data) => {
    try {
        const response = await instanceNew.post('/payment/getCardPaymentSMEMedical', data);
        return response;
    } catch (err) {
        return err;
    }
};


export const getPaymentOptionsTamara = async (data) => {
    try {
        const response = await instanceNew.post('/payment/getPaymentOptionsTamara', data);
        return response;
    } catch (err) {
        //     // console.log("Error : ", err);
    }
};


export const createTamaraSession = async (data) => {
    try {
        const response = await instanceNew.post('/createSession', data);
        return response;
    } catch (err) {
        //     // console.log("Error : ", err);
    }
};


export const verifyTamaraOrder = async (refId, systemId) => {
    try {
        const response = await instanceNew.post('/payment/verifyOrder', utils.verifyOrderRequest(refId,systemId));
        return response;
    } catch (err) {
        //     // console.log("Error : ", err);
    }
};

export const getSadadPayment = async (data) => {
    try {
        const response = await instanceNew.post('/payment/getSadadPaymentGeneration', data);

        return response;
    } catch (err) {
        //     // console.log("Error : ", err);
    }
};


export const medicalSadadPayment = async (data) => {
    //
    try {
        const response = await instanceNew.post('/medicalSME/sadad', data);
        //
        return response;
    } catch (err) {
        //     // console.log("Error : ", err);
        //
    }
};

export const DomesticWOrkSadadPayment = async (data) => {
    try {
        const response = await instanceNew.post('/domestichealthinsurance/generateSADADBill', data, {
            headers: {
                'Authorization': "Bearer " + store?.getState()?.sales?.encyptvalcust || localStorage.getItem("ProductToken"),
            }
        });

        return response;
    } catch (err) {
        //     // console.log("Error : ", err);
    }
};



export const getPaymentById = async (data) => {
    try {
        const response = await instanceNew.post("/payment/getPaymentById", { "id": data });
        return response.data;
    } catch (err) {
        return Promise.reject(err);
    }
};
export const getPaymentByIdDev = async (data) => {
    try {
        const response = await instanceNew.post("/payment/getPaymentByIdDev", { "id": data });
        return response.data;
    } catch (err) {
        return Promise.reject(err);
    }
};

// PolicyDetails

export const getPolicyDetails = async (data) => {
    try {
        const response = await instanceNew.post("/common/getPolicyDetails", data);
        return response.data;
    } catch (err) {
        return Promise.reject(err);
    }
};

//return online policy URL
export const getPolicyInfo = async (data) => {
    try {
        const response = await instanceNew.post("/common/getPolicyInfo", data);
        return response.data;
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getNationalList = async (data) => {
    try {
        const response = await instanceNew.post("/common/getNationalityDescription", data);
        return response.data;
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getOccupationList = async (data) => {
    try {
        const response = await instanceNew.post("/common/getOccupationDescription", data);
        return response.data;
    } catch (err) {
        return Promise.reject(err);
    }
};


export const crmCampaignAttribution = async (reqData) => {
    try {
      const { data } = await instanceNew.post('/common/crmCampaignAttribution', reqData)
      if (data && data.resultCode === 'S') {
        console.log("resultCode",data);
      }
      else Promise.reject(data.resultMessage)
    } catch (error) {
      return Promise.reject(error)
    }
  }

export const submitCRMCampaignApi=async (qNumber,lobcode) => {
    let localData = JSON.parse(await localStorage.getItem("paramAttributes"));
    if(isEmpty(localData)){
        return;
    }
    let {fbclid,utm_source,utm_medium,utm_campaign,utm_content,utm_term,utm_promocode,campid,gclid,ttclid,dclid} =localData;
    let reqData = {
        "fbclid": fbclid || "",
        "utm_source": utm_source || "",
        "utm_medium": utm_medium || "",
        "utm_campaign": utm_campaign || "",
        "utm_content": utm_content || "",
        "utm_term": utm_term || "",
        "utm_promocode": utm_promocode || "",
        "campid": campid || "",
        "gclid": gclid || "",
        "ttclid": ttclid || "",
        "dclid": dclid || "",
        "quotation_no": qNumber?.toString() || "",
        "lobcode": lobcode || "",
    }
    console.log(reqData,'localData####',localData.utm_source);
    crmCampaignAttribution(reqData);
}

export const getApplePaySession = (applePayRequest) =>  {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await instanceNew.post('/applepay/session',applePayRequest);
            resolve (response);
        } catch (err) {
            reject(err);
        }
    })
}

export const getApplePayPayments = (applePayRequest) =>  {
    //req=
    // {
    //     "paymentRequest" : {
    //     "source" : {
    //         "type" : "applepay",
    //             "token" : "tok_lku84uhtqztkeiny8b7c3hcpqa8"
    //     },
    //     "amount" : "1000",
    //         "systemId" : "MOTOR",
    //         "quotationNo" : "12245",
    //         "policyNo" : "",
    //         "tmx" : "",
    //         "reference" : "",
    //         "idNo" : "2392053266",
    //         "mobile" : "966546372656",
    //         "email" : "ksamiuddin@tawuniya.com.sa",
    //         "passportNo" : "",
    //         "lang" : "E"
    // }
    // }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await instanceNew.post('/applepay/payments',applePayRequest);
            // if(response?.data?.getSessionIdResponse?.status === "S"){
            //     let data=response?.data?.getSessionIdResponse?.sessionDetails;
            //     console.log(response?.data,'response?.data#####',response?.data?.getSessionIdResponse?.status === "S");
            //     resolve (data);
            // }else resolve ({});
            resolve (response);
        } catch (err) {
            reject(err);
        }
    })
}


export const getApplePayToken = (applePayRequest) =>  {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await instanceNew.post('/applepay/tokens',applePayRequest);
            // if(response?.data?.getSessionIdResponse?.status === "S"){
            //     let data=response?.data?.getSessionIdResponse?.sessionDetails;
            //     console.log(response?.data,'response?.data#####',response?.data?.getSessionIdResponse?.status === "S");
            //     resolve (data);
            // }else resolve ({});
            resolve (response);
        } catch (err) {
            reject(err);
        }
    })
}